import Select from 'antd/lib/select';
import { useMemo } from 'react';
import { IEmailUtilityAutomation } from '../../domain/email-utility-automation/interface';
import { useEmailUtilityAutomationListQuery } from '../../domain/email-utility-automation/queries';

export const UtilityAutomationSelect = ({ ...props }) => {
    const { data, isLoading } = useEmailUtilityAutomationListQuery({});
    const utilityAutomationOptions = useMemo(() => (data || []).map(transformUtilityAutomationToOption), [data]);

    return (
        <Select allowClear loading={isLoading} placeholder="Select Utility Automation" size="large" options={utilityAutomationOptions} {...props} />
    );
};

function transformUtilityAutomationToOption(utilityAutomation: IEmailUtilityAutomation) {
    return {
        label: utilityAutomation.title,
        value: utilityAutomation.automation_key,
        key: utilityAutomation.automation_key,
    };
}
